import { Outbound } from '@domain/purchasing/models/Outbound';
import { OutboundDTO } from '../dto/OutboundDTO';

export class OutboundMapper {
  static toModel(dto: OutboundDTO): Outbound {
    return {
      quantity: dto.quantity,
      date: new Date(dto.date),
    };
  }

  static toDTO(model: Outbound): OutboundDTO {
    return {
      quantity: model.quantity,
      date: model.date.toISOString(),
    };
  }
}
